import { createPrintJob, type PreviewOptions } from "../../src/index";
import { createInvoiceRows } from "../shared/data";

// The basic example demonstrates browser-driven automatic pagination for a
// long table and lets callers toggle whether headers should repeat on each page.
export function createBasicExample(options: { repeatHeaderOnPageBreak: boolean }) {
  const job = createPrintJob({
    title: "Basic Table Pagination",
    pageSize: "A4",
    orientation: "portrait",
    margins: { top: "14mm", right: "12mm", bottom: "14mm", left: "12mm" },
    fontFamily: '"Segoe UI", "PingFang SC", sans-serif'
  });

  job
    .addText("Basic Table Pagination", {
      tagName: "h1",
      style: {
        margin: 0,
        fontSize: "28px",
        letterSpacing: "0.04em"
      }
    })
    .addHtml(
      `<p style="margin:0;color:#475569;font-size:14px;line-height:1.6;">
        This example has no explicit page break. Paged preview now estimates page
        boundaries from real DOM height so the long table can split into multiple
        pages in a way that is closer to the browser's eventual print result.
      </p>`
    )
    .addTable(
      createInvoiceRows(108),
      [
        { key: "sku", label: "SKU", width: "22mm" },
        { key: "name", label: "Description", width: "92mm" },
        { key: "qty", label: "Qty", width: "18mm", align: "center" },
        { key: "total", label: "Total", width: "28mm", align: "right" }
      ],
      {
        striped: true,
        repeatHeaderOnPageBreak: options.repeatHeaderOnPageBreak
      }
    );

  const previewOptions: Omit<PreviewOptions, "container"> = {
    mode: "document",
    paginationStrategy: "estimate",
    showAutoPaginationHints: true
  };

  return {
    id: "basic",
    title: "Basic Table Pagination",
    description: "Automatic pagination for a long table with optional repeated headers and estimated page boundaries.",
    job,
    defaultPreviewOptions: previewOptions
  };
}
